// extracted by mini-css-extract-plugin
export default {"overflow-handler":"OverflowHandler_overflow-handler__3ySQH","hiddenItemsContainer":"OverflowHandler_hiddenItemsContainer__12P-C","moreIcon":"OverflowHandler_moreIcon__htjiJ"};